<template>
  <div>
    <Modal
      :can-close="true"
      scope="change-currency-and-language"
      :yScroll="false"
      :overflowVisible="true"
      :small="true"
      :active="active"
      @close="$emit('close')"
    >
      <div v-if="contentReady" class="text-center text-black">
        <div class="grid gap-x-2 gap-y-4 grid-cols-8">
          <div v-if="!isCurrencySet" class="col-span-full py-2">
            <h1 class="text-3xl mb-5">{{ currencyTitle }}</h1>
            <Dropdown
              class="w-full"
              :options="currencyOptions"
              :selected="displaySelectedCurrency"
              :hideReset="true"
              :label="displayCurrencyLabel"
              @select="handleCurrencySelect($event)"
            />
          </div>

          <div class="col-span-full py-2">
            <h1 class="text-3xl mb-5">{{ languageTitle }}</h1>
            <Dropdown
              class="no-translate w-full"
              :options="languageOptions"
              :selected="displaySelectedLanguage"
              :hideReset="true"
              :label="displayLanguageLabel"
              @select="handleLanguageSelect($event)"
            />
          </div>

          <button
            type="button"
            class="btn btn-tertiary col-span-3"
            @click="handleCloseModal"
          >
            {{ page.cancel }}
          </button>

          <button
            type="button"
            class="btn btn-secondary col-span-5 mr-0.5"
            @click="onSaveConfirmed"
          >
            {{ page.save }}
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/modals/Modal'
import Dropdown from '~/components/form/Dropdown'
import { getPages } from '@/mixins/content'

export default {
  components: {
    Modal,
    Dropdown,
  },

  props: {
    active: { type: Boolean, default: false },
    currencyTitle: { type: String, default: 'Select your currency' },
    languageTitle: { type: String, default: 'Select your language' },
    currencyOptions: { type: Array, required: true },
    selectedCurrency: { type: String, default: 'usd' },
    languageOptions: { type: Array, required: true },
    selectedLanguage: { type: String, default: 'en' },
    isCurrencySet: { type: Boolean, default: false },
  },

  data: () => ({
    displaySelectedCurrency: '',
    displaySelectedLanguage: '',
  }),

  mounted() {
    this.displaySelectedCurrency = this.selectedCurrency
    this.displaySelectedLanguage = this.selectedLanguage
  },

  mixins: [getPages(['data/call-to-actions'], true)],

  computed: {
    displayCurrencyLabel() {
      const currencyOption = this.currencyOptions.find(
        option => option.ISO === this.displaySelectedCurrency
      )
      return currencyOption ? currencyOption.label : 'Not a valid currency'
    },

    displayLanguageLabel() {
      const languageOption = this.languageOptions.find(
        option => option.handle === this.displaySelectedLanguage
      )
      return languageOption ? languageOption.label : 'Not an available language'
    },
  },

  methods: {
    handleCloseModal(e) {
      e.stopPropagation()
      this.$emit('close')
    },

    handleCurrencySelect(e) {
      this.displaySelectedCurrency = e.ISO
    },

    handleLanguageSelect(e) {
      this.displaySelectedLanguage = e.handle
    },

    onSaveConfirmed(e) {
      e.stopPropagation()

      this.$emit('save', {
        currency: this.displaySelectedCurrency,
        language: this.displaySelectedLanguage,
      })
    },
  },

  watch: {
    selectedCurrency(newVal) {
      this.displaySelectedCurrency = newVal
    },

    selectedLanguage(newVal) {
      this.displaySelectedLanguage = newVal
    },
  },
}
</script>
